import React, { useContext } from 'react'
import { ShopContext } from '../Context/ShopContext'
import { useParams } from 'react-router-dom'
import Breadcrumbs from '../Components/Breadcrumbs/Breadcrumbs';
import Productdisplay from '../Components/Productdisplay/Productdisplay';
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts';

const Product = () => {
  const {all_product} = useContext(ShopContext);
  // const all_product = JSON.parse(localStorage.getItem("all_product"));
  const {productId} = useParams();
  const product = all_product.find((e) => e.id === Number(productId));
  if(product)
    localStorage.setItem("currentProd", JSON.stringify(product));

  return (
    <div>
      <Breadcrumbs></Breadcrumbs>
      <Productdisplay />
      <RelatedProducts />
    </div>
  )
}

export default Product